import React from 'react';

import type { FeatureContentItem } from './index';
import { parseJson } from '@/utils/parseJson';
import { twMerge } from '@weee-fe/module';

interface TitleProps {
  item: FeatureContentItem;
  className?: string;
}

const Title: React.FC<TitleProps> = ({ className, item }) => {
  const { title, title_style } = item;
  const titleStyle = parseJson(title_style) ?? {};

  if (!title) return <></>;
  return (
    <div
      data-role="title"
      className={twMerge('enki-heading-sm text-surface-100-fg-default break-words', className)}
      style={{
        color: titleStyle.color,
        textAlign: titleStyle.align
      }}>
      {title}
    </div>
  );
};

export default Title;
